import { AbstractControl } from '@angular/forms';

import { getTextContentFromHTML } from '@recruitee/utils';

export const isEmptyHtml = (value: string) =>
  !getTextContentFromHTML(value)
    .replace(/\s+?/g, '')
    .replace(/&nbsp;/g, '').length;

export function noHTMLWhitespaceValidator(
  control: AbstractControl,
): { whitespace: boolean } | null {
  const CONSIDER_NON_EMPTY = ['<figure ', '<img '];
  const controlValue = control.value && control.value.toString();
  const hasNonEmptyHTML =
    controlValue && CONSIDER_NON_EMPTY.some(partialTag => controlValue.includes(partialTag));
  if (hasNonEmptyHTML) {
    return null;
  }
  const isValid = !isEmptyHtml(controlValue);

  return isValid ? null : { whitespace: true };
}
